import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { OPERATION_PATH, getOperationById, updateOperation } from '../../api/operationApi';
import { updateOperationAction } from '../../redux/feature/operationSlice';
import { ACCOUNT_PATH, getAccountById, updateAccount } from '../../api/accountApi';

const AccountEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [entity, setEntity] = useState({

    })

    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${ACCOUNT_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${ACCOUNT_PATH}`, false)

    const onClickSubmit = () => {
        updateAccount(id, entity).then(res => {
            closeTab()
            toast.success('İşlem güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    useEffect(() => {
        getAccountById(id).then(res => setEntity(res.data))
    }, [id])

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Hesap Düzenle</label>
                <Input
                    label='Hesap Kodu'
                    name='code'
                    value={entity.code}
                    placeholder='Hesap kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Hesap Adı'
                    name='name'
                    value={entity.name}
                    placeholder='Hesap adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    value={entity.description}
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default AccountEditPage